var map = {
	"./-0.1DarkBlue-.png": 48106,
	"./-0.1Green-.png": 20941,
	"./-0.1LightBlue-.png": 95093,
	"./-0.1Orange-.png": 59729,
	"./-0.1Purple-.png": 43529,
	"./-0.1Yellow-.png": 85277,
	"./-0.2DarkBlue-.png": 19129,
	"./-0.2Green-.png": 81660,
	"./-0.2LightBlue-.png": 37308,
	"./-0.2Orange-.png": 38023,
	"./-0.2Purple-.png": 35625,
	"./-0.2Yellow-.png": 6586,
	"./-0.3DarkBlue-.png": 68432,
	"./-0.3Green-.png": 9945,
	"./-0.3LightBlue-.png": 1278,
	"./-0.3Orange-.png": 86116,
	"./-0.3Purple-.png": 98820,
	"./-0.3Yellow-.png": 6984,
	"./-0.4DarkBlue-.png": 26879,
	"./-0.4Green-.png": 34646,
	"./-0.4LightBlue-.png": 47551,
	"./-0.4Orange-.png": 40514,
	"./-0.4Purple-.png": 25241,
	"./-0.4Yellow-.png": 95185,
	"./-0.5DarkBlue-.png": 35104,
	"./-0.5Green-.png": 9434,
	"./-0.5LightBlue-.png": 38374,
	"./-0.5Orange-.png": 95505,
	"./-0.5Purple-.png": 68124,
	"./-0.5Yellow-.png": 60945,
	"./-0.6DarkBlue-.png": 6519,
	"./-0.6Green-.png": 68125,
	"./-0.6LightBlue-.png": 59386,
	"./-0.6Orange-.png": 38224,
	"./-0.6Purple-.png": 5049,
	"./-0.6Yellow-.png": 20005,
	"./-0.7DarkBlue-.png": 52867,
	"./-0.7Green-.png": 75493,
	"./-0.7LightBlue-.png": 47718,
	"./-0.7Orange-.png": 60509,
	"./-0.7Purple-.png": 95483,
	"./-0.7Yellow-.png": 87336,
	"./-0.8DarkBlue-.png": 79147,
	"./-0.8Green-.png": 55472,
	"./-0.8LightBlue-.png": 89991,
	"./-0.8Orange-.png": 54478,
	"./-0.8Purple-.png": 17725,
	"./-0.8Yellow-.png": 88054,
	"./-0.9DarkBlue-.png": 47871,
	"./-0.9Green-.png": 37088,
	"./-0.9LightBlue-.png": 21738,
	"./-0.9Orange-.png": 73785,
	"./-0.9Purple-.png": 69316,
	"./-0.9Yellow-.png": 81850,
	"./-1.0DarkBlue-.png": 24126,
	"./-1.0Green-.png": 13234,
	"./-1.0LightBlue-.png": 80600,
	"./-1.0Orange-.png": 77817,
	"./-1.0Purple-.png": 28970,
	"./-1.0Yellow-.png": 80748,
	"./-1.1DarkBlue-.png": 30206,
	"./-1.1Green-.png": 68051,
	"./-1.1LightBlue-.png": 49202,
	"./-1.1Orange-.png": 79701,
	"./-1.1Purple-.png": 52358,
	"./-1.1Yellow-.png": 99261,
	"./-1.2DarkBlue-.png": 97298,
	"./-1.2Green-.png": 90212,
	"./-1.2LightBlue-.png": 29438,
	"./-1.2Orange-.png": 95839,
	"./-1.2Purple-.png": 39805,
	"./-1.2Yellow-.png": 18817,
	"./-1.3DarkBlue-.png": 52094,
	"./-1.3Green-.png": 62256,
	"./-1.3LightBlue-.png": 16030,
	"./-1.3Orange-.png": 92556,
	"./-1.3Purple-.png": 24130,
	"./-1.3Yellow-.png": 14087,
	"./-1.4DarkBlue-.png": 89053,
	"./-1.4Green-.png": 73060,
	"./-1.4LightBlue-.png": 25937,
	"./-1.4Orange-.png": 89656,
	"./-1.4Purple-.png": 82774,
	"./-1.4Yellow-.png": 76931,
	"./-1.5DarkBlue-.png": 64224,
	"./-1.5Green-.png": 57749,
	"./-1.5LightBlue-.png": 55005,
	"./-1.5Orange-.png": 3776,
	"./-1.5Purple-.png": 23305,
	"./-1.5Yellow-.png": 21096,
	"./-1.6DarkBlue-.png": 99972,
	"./-1.6Green-.png": 65699,
	"./-1.6LightBlue-.png": 7110,
	"./-1.6Orange-.png": 49462,
	"./-1.6Purple-.png": 91128,
	"./-1.6Yellow-.png": 79976,
	"./-1.7DarkBlue-.png": 56889,
	"./-1.7Green-.png": 85484,
	"./-1.7LightBlue-.png": 63551,
	"./-1.7Orange-.png": 68075,
	"./-1.7Purple-.png": 16807,
	"./-1.7Yellow-.png": 41262,
	"./-1.8DarkBlue-.png": 64657,
	"./-1.8Green-.png": 23473,
	"./-1.8LightBlue-.png": 36857,
	"./-1.8Orange-.png": 69056,
	"./-1.8Purple-.png": 39452,
	"./-1.8Yellow-.png": 69369,
	"./-1.9DarkBlue-.png": 90864,
	"./-1.9Green-.png": 56570,
	"./-1.9LightBlue-.png": 82336,
	"./-1.9Orange-.png": 1454,
	"./-1.9Purple-.png": 44080,
	"./-1.9Yellow-.png": 15049,
	"./-2.0DarkBlue-.png": 23761,
	"./-2.0Green-.png": 6951,
	"./-2.0LightBlue-.png": 77333,
	"./-2.0Orange-.png": 37874,
	"./-2.0Purple-.png": 16935,
	"./-2.0Yellow-.png": 27378,
	"./-2.1DarkBlue-.png": 76946,
	"./-2.1Green-.png": 84405,
	"./-2.1LightBlue-.png": 17921,
	"./-2.1Orange-.png": 39389,
	"./-2.1Purple-.png": 87500,
	"./-2.1Yellow-.png": 18965,
	"./-2.2DarkBlue-.png": 44920,
	"./-2.2Green-.png": 87851,
	"./-2.2LightBlue-.png": 6315,
	"./-2.2Orange-.png": 13796,
	"./-2.2Purple-.png": 35285,
	"./-2.2Yellow-.png": 16423,
	"./-2.3DarkBlue-.png": 53453,
	"./-2.3Green-.png": 6009,
	"./-2.3LightBlue-.png": 49173,
	"./-2.3Orange-.png": 72273,
	"./-2.3Purple-.png": 72867,
	"./-2.3Yellow-.png": 59145,
	"./-2.4DarkBlue-.png": 63951,
	"./-2.4Green-.png": 76380,
	"./-2.4LightBlue-.png": 60549,
	"./-2.4Orange-.png": 10155,
	"./-2.4Purple-.png": 5437,
	"./-2.4Yellow-.png": 95162,
	"./-2.5DarkBlue-.png": 39611,
	"./-2.5Green-.png": 28345,
	"./-2.5LightBlue-.png": 17555,
	"./-2.5Orange-.png": 59571,
	"./-2.5Purple-.png": 88065,
	"./-2.5Yellow-.png": 15073,
	"./-2.6DarkBlue-.png": 55260,
	"./-2.6Green-.png": 193,
	"./-2.6LightBlue-.png": 54306,
	"./-2.6Orange-.png": 87387,
	"./-2.6Purple-.png": 24066,
	"./-2.6Yellow-.png": 33538,
	"./-2.7DarkBlue-.png": 92126,
	"./-2.7Green-.png": 96336,
	"./-2.7LightBlue-.png": 39047,
	"./-2.7Orange-.png": 10984,
	"./-2.7Purple-.png": 1947,
	"./-2.7Yellow-.png": 37671,
	"./-2.8DarkBlue-.png": 96706,
	"./-2.8Green-.png": 12920,
	"./-2.8LightBlue-.png": 90218,
	"./-2.8Orange-.png": 4104,
	"./-2.8Purple-.png": 33875,
	"./-2.8Yellow-.png": 11460,
	"./-2.9DarkBlue-.png": 62741,
	"./-2.9Green-.png": 78671,
	"./-2.9LightBlue-.png": 39070,
	"./-2.9Orange-.png": 5137,
	"./-2.9Purple-.png": 73964,
	"./-2.9Yellow-.png": 40156,
	"./0.0DarkBlue-.png": 27021,
	"./0.0Green-.png": 5861,
	"./0.0LightBlue-.png": 75276,
	"./0.0Orange-.png": 89257,
	"./0.0Purple-.png": 21446,
	"./0.0Yellow-.png": 99110,
	"./0.1DarkBlue-.png": 25425,
	"./0.1Green-.png": 19751,
	"./0.1LightBlue-.png": 41441,
	"./0.1Orange-.png": 61215,
	"./0.1Purple-.png": 99250,
	"./0.1Yellow-.png": 87492,
	"./0.2DarkBlue-.png": 9890,
	"./0.2Green-.png": 79644,
	"./0.2LightBlue-.png": 38770,
	"./0.2Orange-.png": 81825,
	"./0.2Purple-.png": 950,
	"./0.2Yellow-.png": 88239,
	"./0.3DarkBlue-.png": 8305,
	"./0.3Green-.png": 44267,
	"./0.3LightBlue-.png": 60436,
	"./0.3Orange-.png": 3413,
	"./0.3Purple-.png": 55997,
	"./0.3Yellow-.png": 53305,
	"./0.4DarkBlue-.png": 20837,
	"./0.4Green-.png": 81710,
	"./0.4LightBlue-.png": 55865,
	"./0.4Orange-.png": 98477,
	"./0.4Purple-.png": 87072,
	"./0.4Yellow-.png": 68585,
	"./0.5DarkBlue-.png": 9471,
	"./0.5Green-.png": 27141,
	"./0.5LightBlue-.png": 6258,
	"./0.5Orange-.png": 38480,
	"./0.5Purple-.png": 91843,
	"./0.5Yellow-.png": 15793,
	"./0.6DarkBlue-.png": 61426,
	"./0.6Green-.png": 21383,
	"./0.6LightBlue-.png": 61370,
	"./0.6Orange-.png": 33960,
	"./0.6Purple-.png": 45007,
	"./0.6Yellow-.png": 61068,
	"./0.7DarkBlue-.png": 70890,
	"./0.7Green-.png": 90391,
	"./0.7LightBlue-.png": 65025,
	"./0.7Orange-.png": 65475,
	"./0.7Purple-.png": 29471,
	"./0.7Yellow-.png": 27546,
	"./0.8DarkBlue-.png": 95555,
	"./0.8Green-.png": 98688,
	"./0.8LightBlue-.png": 59482,
	"./0.8Orange-.png": 8263,
	"./0.8Purple-.png": 66838,
	"./0.8Yellow-.png": 16977,
	"./0.9DarkBlue-.png": 24519,
	"./0.9Green-.png": 76865,
	"./0.9LightBlue-.png": 1594,
	"./0.9Orange-.png": 66791,
	"./0.9Purple-.png": 22920,
	"./0.9Yellow-.png": 65269,
	"./1.0DarkBlue-.png": 25090,
	"./1.0Green-.png": 31921,
	"./1.0LightBlue-.png": 20497,
	"./1.0Orange-.png": 45776,
	"./1.0Purple-.png": 80527,
	"./1.0Yellow-.png": 73048,
	"./1.1DarkBlue-.png": 47608,
	"./1.1Green-.png": 40760,
	"./1.1LightBlue-.png": 35946,
	"./1.1Orange-.png": 52917,
	"./1.1Purple-.png": 33752,
	"./1.1Yellow-.png": 52393,
	"./1.2DarkBlue-.png": 33510,
	"./1.2Green-.png": 427,
	"./1.2LightBlue-.png": 30504,
	"./1.2Orange-.png": 49562,
	"./1.2Purple-.png": 54651,
	"./1.2Yellow-.png": 23602,
	"./1.3DarkBlue-.png": 29861,
	"./1.3Green-.png": 6837,
	"./1.3LightBlue-.png": 53265,
	"./1.3Orange-.png": 82695,
	"./1.3Purple-.png": 99794,
	"./1.3Yellow-.png": 96399,
	"./1.4DarkBlue-.png": 12459,
	"./1.4Green-.png": 90401,
	"./1.4LightBlue-.png": 50966,
	"./1.4Orange-.png": 91215,
	"./1.4Purple-.png": 15500,
	"./1.4Yellow-.png": 58730,
	"./1.5DarkBlue-.png": 43947,
	"./1.5Green-.png": 85816,
	"./1.5LightBlue-.png": 38340,
	"./1.5Orange-.png": 82542,
	"./1.5Purple-.png": 34340,
	"./1.5Yellow-.png": 5128,
	"./1.6DarkBlue-.png": 61789,
	"./1.6Green-.png": 9025,
	"./1.6LightBlue-.png": 4762,
	"./1.6Orange-.png": 16318,
	"./1.6Purple-.png": 44769,
	"./1.6Yellow-.png": 42962,
	"./1.7DarkBlue-.png": 16621,
	"./1.7Green-.png": 68945,
	"./1.7LightBlue-.png": 14797,
	"./1.7Orange-.png": 57081,
	"./1.7Purple-.png": 27606,
	"./1.7Yellow-.png": 96855,
	"./1.8DarkBlue-.png": 32722,
	"./1.8Green-.png": 68936,
	"./1.8LightBlue-.png": 90377,
	"./1.8Orange-.png": 8558,
	"./1.8Purple-.png": 43356,
	"./1.8Yellow-.png": 17433,
	"./1.9DarkBlue-.png": 59609,
	"./1.9Green-.png": 31833,
	"./1.9LightBlue-.png": 28449,
	"./1.9Orange-.png": 61877,
	"./1.9Purple-.png": 29504,
	"./1.9Yellow-.png": 9231,
	"./2.0DarkBlue-.png": 70249,
	"./2.0Green-.png": 46186,
	"./2.0LightBlue-.png": 67313,
	"./2.0Orange-.png": 57616,
	"./2.0Purple-.png": 9556,
	"./2.0Yellow-.png": 53813,
	"./2.1DarkBlue-.png": 69705,
	"./2.1Green-.png": 48953,
	"./2.1LightBlue-.png": 45051,
	"./2.1Orange-.png": 29508,
	"./2.1Purple-.png": 1047,
	"./2.1Yellow-.png": 69410,
	"./2.2DarkBlue-.png": 73453,
	"./2.2Green-.png": 47351,
	"./2.2LightBlue-.png": 98456,
	"./2.2Orange-.png": 33173,
	"./2.2Purple-.png": 92090,
	"./2.2Yellow-.png": 28764,
	"./2.3DarkBlue-.png": 88654,
	"./2.3Green-.png": 99309,
	"./2.3LightBlue-.png": 87300,
	"./2.3Orange-.png": 90619,
	"./2.3Purple-.png": 58644,
	"./2.3Yellow-.png": 23433,
	"./2.4DarkBlue-.png": 34163,
	"./2.4Green-.png": 85179,
	"./2.4LightBlue-.png": 75709,
	"./2.4Orange-.png": 19401,
	"./2.4Purple-.png": 32393,
	"./2.4Yellow-.png": 63083,
	"./2.5DarkBlue-.png": 63084,
	"./2.5Green-.png": 26943,
	"./2.5LightBlue-.png": 24879,
	"./2.5Orange-.png": 66930,
	"./2.5Purple-.png": 7205,
	"./2.5Yellow-.png": 46242,
	"./2.6DarkBlue-.png": 44149,
	"./2.6Green-.png": 62859,
	"./2.6LightBlue-.png": 57614,
	"./2.6Orange-.png": 13278,
	"./2.6Purple-.png": 94442,
	"./2.6Yellow-.png": 95096,
	"./2.7DarkBlue-.png": 52280,
	"./2.7Green-.png": 75980,
	"./2.7LightBlue-.png": 1406,
	"./2.7Orange-.png": 36133,
	"./2.7Purple-.png": 80458,
	"./2.7Yellow-.png": 49538,
	"./2.8DarkBlue-.png": 33228,
	"./2.8Green-.png": 7001,
	"./2.8LightBlue-.png": 78505,
	"./2.8Orange-.png": 62686,
	"./2.8Purple-.png": 55563,
	"./2.8Yellow-.png": 8425,
	"./2.9DarkBlue-.png": 92418,
	"./2.9Green-.png": 16139,
	"./2.9LightBlue-.png": 65502,
	"./2.9Orange-.png": 5940,
	"./2.9Purple-.png": 54953,
	"./2.9Yellow-.png": 71175,
	"./3.0DarkBlue-.png": 79245,
	"./3.0Green-.png": 26021,
	"./3.0LightBlue-.png": 66177,
	"./3.0Orange-.png": 55001,
	"./3.0Purple-.png": 60203,
	"./3.0Yellow-.png": 56539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84250;